import { Flex } from '@teamsparta/stack-flex';
import Image from 'next/image';

import { Button } from '@/pages/campaign/shared/Button/template';

import * as D from './data';
import * as S from './style';

export function BonusEvent() {
  function handleClickCloseCampaign() {
    alert('참여 기간이 종료되었어요.');
    return;
  }

  return (
    <>
      {D.BONUS_EVENT_DATA.map((data, index) => {
        return (
          <S.Wrapper key={index}>
            <Flex.Column
              justify='center'
              align='start'
              gap='12px'
              style={{ width: '100%', alignItems: 'flex-start' }}
            >
              <S.Title>{data.title}</S.Title>
              <div>
                {data.info.map((info, i) => (
                  <S.Info key={i}>{info}</S.Info>
                ))}
              </div>
            </Flex.Column>
            <S.ImageContainer>
              <S.ImageWrapper>
                <Image
                  src='/images/campaign/campaign_event_mac.png'
                  fill
                  alt='event mac'
                />
              </S.ImageWrapper>
              <S.Description>{data.description}</S.Description>
            </S.ImageContainer>
            <div>
              <Button onClick={handleClickCloseCampaign}>
                참여 기간이 종료되었어요.
              </Button>
            </div>
          </S.Wrapper>
        );
      })}
    </>
  );
}
